var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"menu_none"},[_c('div',{staticClass:"wrap menu_none"},[_c('p',{attrs:{"id":"copyright"}},[_vm._v("© "+_vm._s(new Date().getFullYear())+" 複眼経済塾株式会社 All Rights Reserved.")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }